module.exports = __webpack_public_path__ + "static/media/roadtrip.84c78f83.jpg";